/**
 * Design tokens and layout constants for consistent UI
 */

export const Z_INDEX = {
  backdrop: 40,
  drawer: 50,
  navigation: 60,
  modal: 70,
  tooltip: 80,
} as const;

export const LAYOUT = {
  mobileNavHeight: '5rem', // 80px
  mobileNavHeightPx: 80,
} as const;

export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1280px',
} as const;

export const TRANSITIONS = {
  default: 'transition-all duration-300 ease-in-out',
  fast: 'transition-all duration-150 ease-in-out',
  slow: 'transition-all duration-500 ease-in-out',
} as const;

export const COLORS = {
  backdrop: 'bg-black bg-opacity-50',
  mobileNavBg: 'bg-black/70',
  drawerBg: 'bg-white',
} as const;